import React from 'react'
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { GoDotFill } from "react-icons/go";
import { ServiceCard } from '../serviceCard/ServiceCard';
import { useNavigate } from 'react-router-dom';
import SearchProductCard from '../productCard/searchProductCard';


export const VendorProductServiceCard = ({ cardType, data }) => {
    let item = data
    const navigate = useNavigate()

    return (
        <div className='vendorProductServiceCard'>
            <div className='vendorProductServiceCardBody'>
                <div className='searchResultCardHeader' onClick={() => navigate(`/vendor/${item?.vendor_id}`)}>
                    <div className='vendorName'>
                        <span>{item?.vendor_company_name}</span>
                        <MdOutlineArrowForwardIos size={19} color='rgba(152, 152, 152, 1)' />
                    </div>
                    <div className='address'>
                        <span><GoDotFill /> {item?.vendor_category_name}</span>
                        <span><GoDotFill />
                            {item?.vendor_address && item?.vendor_address.length > 40
                                ? item?.vendor_address.slice(0, 35) + "..."
                                : item?.vendor_address}
                        </span>
                        <span><GoDotFill /> {item?.distance}Km</span>
                    </div>
                </div>

                <div>
                    <div className="mt-2"  >
                        <div className="d-flex scroller-style-x">
                            {cardType == "Service" &&
                                item?.services?.map((service) => (
                                    <ServiceCard
                                        key={service.service_id}
                                        forCart={item}
                                        data={service}
                                    />
                                ))}

                            {cardType == "Product" &&
                                item?.products?.map((product) => (
                                    <SearchProductCard
                                        key={product.product_id}
                                        forCart={item}
                                        data={product}
                                    />
                                ))}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
